import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const deleteNotification = async (id: string) => {
  try {
    const url = `${urls.DELETE_NOTIFICATION}/${id}`;
    const callParams = await getCallParams("DELETE");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteAllNotifications = async () => {
  try {
    const url = `${urls.DELETE_ALL_NOTIFICATION}`;
    const callParams = await getCallParams("DELETE");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const markAsReadAll = async () => {
  try {
    const url = `${urls.MARK_AS_READ_ALL}`;
    const callParams = await getCallParams("PATCH");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const markAsRead = async (id: string) => {
  try {
    const url = `${urls.MARK_AS_READ}/${id}`;
    const callParams = await getCallParams("PATCH");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getUnreadNotificationCount = async () => {
  const url = `${urls.GET_NOTIFICATION_COUNT}/unread/notifications/count`;
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getAllNotificationCount = async () => {
  const url = `${urls.GET_NOTIFICATION_COUNT}/all/notifications/count`;
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
